//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import UiLazyImg from "@/components/Ui/UiLazyImg.vue";

export default {
  name: "StoneBlock",
  components: {
    UiLazyImg,
    VueSlickCarousel
  },
  props: {
    slides: {
      type: Array,
      default() {
        return []
      }
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    stoneShapes: {
      type: Array,
      default() {
        return []
      }
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      currentSlideIndex: 0,
      slidesUpdated: true,
    }
  },
  watch: {
    slides(val, oldVal) {
      if (val?.map(item => item.attribute_id).join() === oldVal?.map(item => item.attribute_id).join()) {
        return;
      }
      this.resetSlider();
      this.slidesUpdated = false;
      setTimeout(() => {
        this.slidesUpdated = true;
      }, 100);
    },
  },
  computed: {
    currentSlide() {
      return this.slides[this.currentSlideIndex];
    }
  },
  methods: {
    resetSlider() {
      this.currentSlideIndex = 0;
    },
    afterChange(e) {
      this.currentSlideIndex = e;
    },
  }
}
